<template>
  <section class="row flexbox-container">
    <div class="col-xl-8 col-11 d-flex justify-content-center">
      <div class="card bg-authentication rounded-0 mb-0">
        <div class="row m-0">

          <!-- LEFT IMAGE -->
          <div class="col-lg-6 d-lg-block d-none text-center align-self-center px-1 py-0">
            <img src="images/pages/login.png" width="500px" alt="branding logo">
          </div>

          <!-- RIGHT FORM -->
          <div class="col-lg-6 col-12 p-0">
            <div class="card rounded-0 mb-0 px-2">
              <div class="card-header pb-1">
                <div class="card-title" style="margin-top: 60px;">
                  <h4 class="mb-0">Reset Default Password</h4>
                </div>
              </div>

              <p class="px-2">
                Enter your Tax ID and your new password. We’ll update your username & password and log you in.
              </p>

              <div class="card-content">
                <div class="card-body pt-1">
                  <form
                    id="resetDefaultForm"
                    @submit.prevent="submit"
                    @keydown="form.errors.clear($event.target.name)"
                  >
                    <!-- TAX ID -->
                    <fieldset class="form-label-group form-group position-relative has-icon-left">
                      <input
                        type="text"
                        name="tax_id"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('tax_id') }"
                        placeholder="Tax ID"
                        v-model="form.tax_id"
                      />
                      <div class="form-control-position">
                        <i class="feather icon-credit-card"></i>
                      </div>
                      <label for="tax_id">Tax ID</label>
                      <show-error :form-name="form" prop-name="tax_id"></show-error>
                    </fieldset>

                    <!-- PASSWORD -->
                    <fieldset class="form-label-group form-group position-relative has-icon-left">
                      <input
                        type="password"
                        name="password"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('password') }"
                        :placeholder="trans('auth.password')"
                        v-model="form.password"
                      />
                      <div class="form-control-position">
                        <i class="feather icon-lock"></i>
                      </div>
                      <label for="password">{{ trans('auth.password') }}</label>
                      <show-error :form-name="form" prop-name="password"></show-error>
                    </fieldset>

                    <!-- OPTIONAL CONFIRM PASSWORD (if you want same as backend confirmed rule) -->
                    <fieldset class="form-label-group form-group position-relative has-icon-left">
                      <input
                        type="password"
                        name="password_confirmation"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('password_confirmation') }"
                        placeholder="Confirm Password"
                        v-model="form.password_confirmation"
                      />
                      <div class="form-control-position">
                        <i class="feather icon-lock"></i>
                      </div>
                      <label for="password_confirmation">Confirm Password</label>
                      <show-error :form-name="form" prop-name="password_confirmation"></show-error>
                    </fieldset>

                    <div class="d-flex justify-content-between align-items-center">
                      <router-link to="/login" class="card-link">
                        Back to Login
                      </router-link>

                      <button-spinner
                        :is-loading="form.isLoading"
                        :disabled="form.isLoading"
                        class="btn btn-primary btn-inline"
                        style="height: 39px; color: #fff;"
                      >
                        Reset & Login
                      </button-spinner>
                    </div>
                  </form>
                </div>
              </div>

              <div class="login-footer">
                <div class="divider">
                  <div class="divider-text">OR</div>
                </div>
                <div class="footer-btn d-inline">
                  <router-link to="/pay-tax" class="btn btn-outline-primary btn-inline" v-if="getConfig('registration')">
                    Pay Tax
                  </router-link>
                  <button type="button" class="btn btn-outline-primary float-right btn-inline">
                    Tax Calculator
                  </button>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: new Form({
        isLoading: false,
        tax_id: '',
        password: '',
        password_confirmation: ''
      })
    }
  },

  mounted() {
    // If you want same notice modal behavior, you can keep it,
    // otherwise remove this.
    // $('#notification').modal('show');
  },

  methods: {
    submit() {
      this.form.isLoading = true;

      this.form.post('/api/auth/reset-default')
        .then(response => {
          // login same way you do in login.vue
          localStorage.setItem('auth_token', response.token);
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');

          this.$store.dispatch('setAuthStatus');
          this.$store.dispatch('setLastActivity');

          this.form.isLoading = false;
          toastr.success(response.message);

          if (helper.getConfig('two_factor_security') && response.two_factor_code) {
            this.$store.dispatch('setTwoFactorCode', response.two_factor_code);
            this.$router.push('/auth/security');
          } else {
            const redirect_path = response.reload ? '/home?reload=1' : '/home';
            this.$store.dispatch('resetTwoFactorCode');
            this.$router.push(redirect_path);
          }
        })
        .catch(error => {
          this.form.isLoading = false;
          helper.showErrorMsg(error);
          toastr.error(error.message);
        });
    },

    getConfig(config) {
      return helper.getConfig(config);
    }
  }
}
</script>
